module.exports = __webpack_public_path__ + "img/test-avatar.91e50cc7.png";